<nh-alert type="danger" [isOpen]="isInvalidFileSize">
  <div class="row">
    <div class="col-auto icon">
      <img src="../../../assets/images/Icons/⚛️ icons-alert-circle-outline.svg" alt="" />
    </div>
    <div class="col message">
      <span>{{ 'FILE_SIZE' | globalTranslate}}</span>
    </div>
  </div>
</nh-alert>
<nh-alert type="danger" [isOpen]="showErrorMessage">
  <div class="row">
    <div class="col-auto icon">
      <img src="../../../assets/images/Icons/⚛️ icons-alert-circle-outline.svg" alt="" />
    </div>
    <div class="col message">
      <span>{{ 'ERROR_FILE_UPLOAD' | globalTranslate}}</span>
    </div>
  </div>
</nh-alert>
<nh-alert type="danger" [isOpen]="isPasswordProtected">
  <div class="row">
    <div class="col-auto icon">
      <img src="../../../assets/images/Icons/⚛️ icons-alert-circle-outline.svg" alt="" />
    </div>
    <div class="col message">
      <span>{{ 'FILE_PWD_PROTECTED' | globalTranslate}}</span>
    </div>
  </div>
</nh-alert>
<nh-alert type="danger" [isOpen]="isInvalidFileType">
  <div class="row">
    <div class="col-auto icon">
      <img src="../../../assets/images/Icons/⚛️ icons-alert-circle-outline.svg" alt="" />
    </div>
    <div class="col message">
      <span class="nh-table-mobile d-lg-none ">{{ 'FILE_TYPE' | globalTranslate}}</span>
    </div>
  </div>
</nh-alert>
<div ng2FileDrop [ngClass]="{'nv-file-over': hasBaseDropZoneOver}" (fileOver)="fileOverBase($event)"
  [uploader]="uploader" (onFileDrop)="onFileSelected($event)" class="file-upload">
  <!-- <i class="fa fa-upload"></i> -->
  <img [attr.aria-label]="'fileUpload icon' | globalTranslate" src="../../../assets/images/⚛️ icons-arrow-up-circle-outline.svg">
  <div class="d-block d-lg-none hover-red">
      <a class="btn btn-link hover-red">
        <span class="pe-2" tabindex="0" (click)="displayLoading && !isInvalidFileSize && !showErrorMessage && !isPasswordProtected && !isInvalidFileType ? null : fileInput.click()">{{'UPLOAD_FILE' | globalTranslate}}</span>
      </a>
  </div>
  <div class="d-none d-lg-block">
      <a class="btn btn-link drag-drop-style">
        <span class="pe-2">{{'DRAG_AND_DROP_FILES' | globalTranslate }}</span>
      </a>
  </div>
</div>

<br>

<div>
  <button class="d-none d-lg-block btn d-grid btn-secondary" (click)="fileInput.click()" type="button" id="loadFileXml"
      value="loadXml"> {{'CHOOSE_FILE' | globalTranslate }} </button>
</div>
<div class="nh-table-mobile d-lg-none small light-text pt-2">{{'UPLOAD_DOC_TEXT5' | globalTranslate }}: .tiff, .bmp, .jpg, .pdf </div>
<input #fileInput [uploader]="uploader" style="display: none;" id="file" name="file" ng2FileSelect type="file"
  (onFileSelected)="onFileSelected($event)" />